import { Component } from '@angular/core';
import { FormArray, FormControl, ReactiveFormsModule } from '@angular/forms';
import { TranslatePipe } from '@ngx-translate/core';
import {
	ButtonIconComponent,
	FormGroupComponent,
	ISelect,
	ITab,
	InputComponent,
	ItemComponent,
	MenuComponent,
	SelectComponent,
	TagComponent,
	TileComponent,
} from '@tecalisdev/infinity';
import { TextLocalePreviewComponent } from '../../../../shared/components/text-locale-preview/text-locale-preview.component';
import { MenuItemAction } from '../../../../shared/models/master.models';
import { OPERATION_TYPE } from '../../../../operations/models/operations.models';
import { WorkflowFormOperationPanelBase } from './workflow-form-operation-panel.base';
import { WorkflowFormAdvancedCollapseComponent } from '../workflow-form-advanced-collapse.component';

/**
 * Panel UI de HOME en el editor (NIF-530).
 * Abrir cuando: policy checks / pautas Tecalis / description multi-locale.
 */
@Component({
	selector: 'app-workflow-form-home-panel',
	imports: [
		WorkflowFormAdvancedCollapseComponent,
		ReactiveFormsModule,
		TranslatePipe,
		TileComponent,
		ItemComponent,
		TagComponent,
		FormGroupComponent,
		SelectComponent,
		InputComponent,
		MenuComponent,
		ButtonIconComponent,
		TextLocalePreviewComponent,
	],
	templateUrl: './workflow-form-home-panel.component.html',
})
export class WorkflowFormHomePanelComponent extends WorkflowFormOperationPanelBase {
	protected readonly operationType = OPERATION_TYPE.HOME;
	public readonly MenuItemAction = MenuItemAction;

	public get expandHomeIndicationsForLocaleScroll(): boolean {
		return this.host.expandHomeIndicationsForLocaleScroll;
	}

	public get workflowLocaleTabs(): ITab[] {
		return this.host.workflowLocaleTabs;
	}

	public get checksArray(): FormArray {
		return this.host.checksArray;
	}

	public get policyChecksOptions(): ISelect[] {
		return this.host.policyChecksOptions;
	}

	public get selectedPolicyCheckControl(): FormControl {
		return this.host.selectedPolicyCheckControl;
	}

	public get tecalisPolicyCheck(): boolean {
		return this.readBool('tecalis_policy_check');
	}

	public getWorkflowLocaleControl(...segments: string[]): FormControl {
		return this.host.getWorkflowLocaleControl(...segments);
	}

	public tecalisPolicyMenuChange(event: unknown): void {
		this.host.tecalisPolicyMenuChange(event);
	}

	public policyCheckMenuChange(event: unknown, index: number): void {
		this.host.policyCheckMenuChange(event, index);
	}

	public addPolicyCheck(event: string | ISelect | ISelect[] | unknown): void {
		this.host.addPolicyCheck(event);
	}

	public openCreateTermsModal(): void {
		this.host.showModalTermsConditions = { mode: MenuItemAction.CREATE };
	}
}
